import styled from 'styled-components'
import { breakpoint } from 'utils/consts/breakpoints'

export const Overlay = styled.section<{ isMounted: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  pointer-events: auto;
  background-color: ${props =>
    !props.isMounted ? 'rgba(18, 20, 50, 0.70)' : 'none'};
`
export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  pointer-events: auto;
`
export const Highlight = styled.div<{
  dimensions: { top: number; left: number; height: number; width: number }
  gap: { top: number; left: number; right: number; bottom: number }
}>`
  position: absolute;
  box-shadow: 0 0 0 9999px rgba(18, 20, 50, 0.7);
  z-index: 10000;
  pointer-events: auto;
  height: ${props => props.dimensions.height + props.gap.bottom * 2}px;
  width: ${props => props.dimensions.width + props.gap.right * 2}px;
  top: ${props => props.dimensions.top - props.gap.top}px;
  left: ${props => props.dimensions.left - props.gap.left}px;
  border-radius: 8px;
`

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px 8px 8px 12px;
`
export const TooltipContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 288px;
  border: 1px solid var(--color-sw-10);
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 10001;

  .tooltip-arrow {
    margin-top: -9px;
  }

  @media screen and ${breakpoint.s} {
    width: 344px;
  }
`
export const Title = styled.div`
  font: var(--typography-14-20-semibold);
  color: var(--color-night);
`
export const Content = styled.div`
  box-sizing: border-box;
  font: var(--typography-12-16-regular);
  color: var(--color-sw-60);
  padding: 0 12px 12px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-line;
`
export const CrossIconWrapper = styled.div`
  cursor: pointer;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const Footer = styled.div`
  box-sizing: border-box;
  height: 40px;
  display: flex;
  width: 100%;
  max-width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-top: 1px solid var(--color-sw-10);
`
export const Left = styled.div`
  display: flex;
  font: var(--typography-12-16-semibold);
  color: var(--color-sw-60);
`
export const Right = styled.div`
  display: flex;
  gap: 4px;
`
export const RedButton = styled.div`
  box-sizing: border-box;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: var(--color-brand-red);
  font: var(--typography-12-16-semibold);
  color: var(--color-white);
  cursor: pointer;
`
export const WhiteButton = styled.div`
  box-sizing: border-box;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--color-sw-10);
  background: var(--color-white);
  font: var(--typography-12-16-semibold);
  color: var(--color-sw-60);
  cursor: pointer;
`
